"use client";

// src/portal/portal-context.ts
import { createContext } from "react";
var PortalContext = createContext(null);

export {
  PortalContext
};
